module.exports = __webpack_public_path__ + "img/guide_ui.1ee3e1bc.png";